import { Injectable, Renderer2, SimpleChanges } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class FloatingLabelService {
  new1FunctionCall(
    changes: SimpleChanges,
    appPaymentsFloatingLabel: HTMLElement | null | undefined,
    textLabel: unknown,
    isRequired: boolean,
    isOptional: boolean,
    _renderer: Renderer2
  ) {
    if (
      changes['appPaymentsFloatingLabel'] &&
      changes['appPaymentsFloatingLabel'].previousValue !==
        changes['appPaymentsFloatingLabel'].currentValue
    ) {
      this.funAppFloatingLabel(
        appPaymentsFloatingLabel,
        textLabel,
        isRequired,
        isOptional,
        _renderer
      );
    }
  }

  funAppFloatingLabel(
    appPaymentsFloatingLabel: HTMLElement | null | undefined,
    textLabel: unknown,
    isRequired: boolean,
    isOptional: boolean,
    _renderer: Renderer2
  ) {
    if (appPaymentsFloatingLabel) {
      _renderer.removeChild(appPaymentsFloatingLabel, textLabel);
    }
    textLabel = _renderer.createText(
      appPaymentsFloatingLabel +
        (isRequired ? ' (Required)' : '') +
        (isOptional ? ' (Optional)' : '')
    );
    this.funAppFloatingRenderer(appPaymentsFloatingLabel, textLabel, _renderer);
  }

  funAppFloatingRenderer(
    appPaymentsFloatingLabel: HTMLElement | null | undefined,
    textLabel: unknown,
    _renderer: Renderer2
  ) {
    if (appPaymentsFloatingLabel) {
      _renderer.appendChild(appPaymentsFloatingLabel, textLabel);
    }
  }

  new2FunctionCall(
    changes: SimpleChanges,
    _placeHolderLabel: string | undefined,
    _placeholderValue: string | undefined,
    _isRequiredforPlaceholder: boolean,
    _isOptionalforPlaceholder: boolean,
    _elementRefnewFunc2: unknown,
    _renderer: Renderer2
  ) {
    if (
      changes['placeholderValue'] &&
      changes['placeholderValue'].previousValue !==
        changes['placeholderValue'].currentValue
    ) {
      this.funPlaceholderLabel(
        _placeHolderLabel,
        _placeholderValue,
        _isRequiredforPlaceholder,
        _isOptionalforPlaceholder,
        _elementRefnewFunc2,
        _renderer
      );
    }
  }

  funPlaceholderLabel(
    placeHolderLabel: string | undefined,
    placeholderValue: string | undefined,
    isRequiredforPlaceholder: boolean,
    isOptionalforPlaceholder: boolean,
    elementRefnewFunc2: unknown,
    _renderer: Renderer2
  ) {
    placeHolderLabel =
      placeholderValue +
      (isRequiredforPlaceholder ? ' (Required)' : '') +
      (isOptionalforPlaceholder ? ' (Optional)' : '');
    _renderer.setAttribute(
      elementRefnewFunc2,
      'placeholder',
      placeHolderLabel.trim()
    );
  }

  new3FunctionCall(
    changes: SimpleChanges,
    appPaymentsFloatingLabel: HTMLElement | null | undefined,
    elementRefNewFunc3: unknown,
    renderer: Renderer2
  ) {
    if (
      changes['labelvalue'] &&
      changes['labelvalue'].previousValue !== changes['labelvalue'].currentValue
    ) {
      this.fourthIfFunciton(
        changes,
        appPaymentsFloatingLabel,
        elementRefNewFunc3,
        renderer
      );
    }
  }

  fourthIfFunciton(
    changes: SimpleChanges,
    appPaymentsFloatingLabel: HTMLElement | null | undefined,
    elementRefNewFunc3: unknown,
    renderer: Renderer2
  ) {
    if (appPaymentsFloatingLabel) {
      appPaymentsFloatingLabel.innerText = changes['labelvalue'].currentValue;
      if (appPaymentsFloatingLabel.innerText) {
        renderer.setAttribute(
          elementRefNewFunc3,
          'placeholder',
          changes['labelvalue'].currentValue.trim()
        );
      }
    }
  }
}
